/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminGetListForAuction } from '../fn/admin-auctions-controller/admin-get-list-for-auction';
import { AdminGetListForAuction$Params } from '../fn/admin-auctions-controller/admin-get-list-for-auction';
import { ItemAuctionWithRelations } from '../models/item-auction-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminAuctionsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemAuctionControllerAdminGetListForAuction()` */
  static readonly ItemAuctionControllerAdminGetListForAuctionPath = '/admin/auctions/{id}/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminGetListForAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForAuction$Response(params: AdminGetListForAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemAuctionWithRelations>>> {
    return adminGetListForAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminGetListForAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminGetListForAuction(params: AdminGetListForAuction$Params, context?: HttpContext): Observable<Array<ItemAuctionWithRelations>> {
    return this.adminGetListForAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemAuctionWithRelations>>): Array<ItemAuctionWithRelations> => r.body)
    );
  }

}
